export default "__VITE_ASSET__BPiuVKbM__"